// ============================================================================
// UKRAINIAN TRANSLATIONS - CHAPTER 7: ПОСЛАННЯ ТА ОДКРОВЕННЯ
// ============================================================================
// Рівні 79-91 (13 рівнів, 39 питань)

export const chapter7Translations = {
  name: "Послання та Одкровення",
  description: "Той, хто переможе, успадкує все це... Мудрість згори освячує розуміння",
  
  spiritualWisdom: {
    principle: "Мудрість згори освячує розуміння і оживляє дух",
    scripture: "А якщо кому з вас бракує мудрості, нехай просить у Бога (Якова 1:5)",
    application: "Кожне апостольське послання і кожне видіння Одкровення поглиблює наше розуміння і зміцнює нашу надію"
  },
  
  levels: {
    79: {
      name: "Арешт у Єрусалимі",
      challenge: "Я готовий не лише бути ув'язненим, але й померти в Єрусалимі...",
      easy: {
        question: "Де був заарештований Павло під час своєї останньої подорожі?",
        options: ["Антіохія", "Ефес", "Єрусалим", "Коринф"],
        correctAnswer: 2,
        hint: "Святе місто, яке часто переслідувало пророків",
        funFact: "🏛️ Єрусалим: місце слави і страждань для всіх слуг Божих!"
      },
      medium: {
        question: "У чому іудеї звинуватили Павла?",
        options: [
          "У крадіжці зі Храму",
          "У оскверненні Храму через введення язичників",
          "У богохульстві проти Мойсея",
          "У повстанні проти Риму"
        ],
        correctAnswer: 1,
        hint: "Звинувачення пов'язане з універсальністю Євангелія",
        funFact: "⛪ Парадокс: Павла звинуватили в оскверненні Храму, який він глибоко шанував!"
      },
      hard: {
        question: "Як Павло перетворив своє ув'язнення на можливість?",
        options: [
          "Він втік",
          "Він свідчив перед владою і написав свої послання",
          "Він мовчав",
          "Він вимагав звільнення"
        ],
        correctAnswer: 1,
        hint: "Про перетворення випробувань на свідчення",
        funFact: "⛓️ Фізичні кайдани, духовна свобода - потужне свідчення віри!"
      }
    },
    
    80: {
      name: "Перед намісником Феліксом",
      challenge: "Коли він говорив про справедливість, самоконтроль і майбутній суд...",
      easy: {
        question: "Перед яким намісником Павло свідчив про свою віру?",
        options: ["Пилат", "Фелікс", "Фест", "Галліон"],
        correctAnswer: 1,
        hint: "Намісник, відомий своєю жадібністю",
        funFact: "⚖️ Фелікс сподівався на хабар - корупція перед справедливістю!"
      },
      medium: {
        question: "Як Фелікс відреагував на послання Павла?",
        options: [
          "Він покаявся",
          "Він злякався і затремтів",
          "Він знехтував",
          "Йому було байдуже"
        ],
        correctAnswer: 1,
        hint: "Совість, порушена істиною",
        funFact: "😰 Навіть корумповані тремтять перед істиною Божою - універсальна совість!"
      },
      hard: {
        question: "Чому Фелікс тримав Павла у в'язниці два роки?",
        options: [
          "Щоб захистити його",
          "З політичних міркувань і в надії на корупцію",
          "Він забув",
          "З віри"
        ],
        correctAnswer: 1,
        hint: "Про політичні і особисті розрахунки",
        funFact: "🏛️ Зіпсоване людське правосуддя vs досконале правосуддя Боже - велика різниця!"
      }
    },

    81: {
      name: "Апеляція до Кесаря",
      challenge: "Я апелюю до Кесаря!",
      easy: {
        question: "Яким правом Павло скористався, щоб уникнути суду в Єрусалимі?",
        options: [
          "Правом притулку",
          "Апеляцією до Кесаря (римське громадянство)",
          "Правом втечі",
          "Дипломатичним захистом"
        ],
        correctAnswer: 1,
        hint: "Привілеї його римського громадянства",
        funFact: "🏛️ Римське громадянство: божественний паспорт для донесення Євангелія до Риму!"
      },
      medium: {
        question: "Перед ким Павло свідчив перед відплиттям?",
        options: [
          "Синедріон",
          "Цар Агріппа та Берніке",
          "Римські солдати",
          "Юдейський натовп"
        ],
        correctAnswer: 1,
        hint: "Іудеїзована гілка царства Іродіян",
        funFact: "👑 Від пастуха овець до королівського палацу - божественне піднесення Павла!"
      },
      hard: {
        question: "Як Бог використовує людські системи для Своїх планів?",
        options: [
          "Він їх ігнорує",
          "Він використовує їх суверенно для здійснення Своїх цілей",
          "Він їх руйнує",
          "Він завжди протистоїть"
        ],
        correctAnswer: 1,
        hint: "Про суверенітет Бога над історією",
        funFact: "🌐 Римське право стає інструментом Євангелія - дивовижне провидіння!"
      }
    },

    82: {
      name: "Корабельна аварія на Мальті",
      challenge: "Не бійся, Павле; ти повинен постати перед Кесарем...",
      easy: {
        question: "На якому острові зазнав корабельної аварії Павло?",
        options: ["Крит", "Кіпр", "Мальта", "Сицилія"],
        correctAnswer: 2,
        hint: "Маленький острів на південь від Сицилії",
        funFact: "🏝️ Мальта: обов'язкова зупинка стає плідною місією - шляхи Божі!"
      },
      medium: {
        question: "Які чудеса здійснив Павло на Мальті?",
        options: [
          "Він заспокоїв бурю",
          "Він зцілив батька Публія та інших хворих",
          "Він примножив їжу",
          "Він воскресив мертвих"
        ],
        correctAnswer: 1,
        hint: "Численні зцілення на острові",
        funFact: "🏥 Павло: від жертви корабельної аварії до чудотворного лікаря - божественна слава!"
      },
      hard: {
        question: "Що ця корабельна аварія показує про вірність Бога?",
        options: [
          "Нещасні випадки трапляються",
          "Бог захищає і виконує Свої обіцянки, незважаючи на перешкоди",
          "Павлові просто пощастило",
          "Цього можна було уникнути"
        ],
        correctAnswer: 1,
        hint: "Про вірність Бога обіцянкам",
        funFact: "⛈️ Буря, корабельна аварія, змія: ніщо не може зупинити Божий план для Павла!"
      }
    },

    83: {
      name: "Павло в Римі",
      challenge: "Він прожив два повні роки в орендованому будинку...",
      easy: {
        question: "В яких умовах жив Павло в Римі?",
        options: [
          "У замкненій в'язниці",
          "Під домашнім арештом",
          "У повній свободі",
          "У вигнанні"
        ],
        correctAnswer: 1,
        hint: "Відносна свобода під охороною",
        funFact: "🏠 Будинок-в'язниця стає центром місії - свобода в кайданах!"
      },
      medium: {
        question: "Що робив Павло протягом двох років у Римі?",
        options: [
          "Він відпочивав",
          "Він навчав і писав свої послання",
          "Він готувався до захисту",
          "Він подорожував"
        ],
        correctAnswer: 1,
        hint: "Інтенсивне служіння, незважаючи на кайдани",
        funFact: "✍️ Тюремні послання: Ефесянам, Філіпійцям, Колосянам, Филимону!"
      },
      hard: {
        question: "Як Павло завершив своє служіння згідно з переказами?",
        options: [
          "Він помер від хвороби",
          "Його обезголовили при Нероні близько 67 року н.е.",
          "Він помер від старості",
          "Він таємничо зник"
        ],
        correctAnswer: 1,
        hint: "Мучеництво при божевільному імператорі",
        funFact: "⚔️ 'Я добре змагався, закінчив біг' - остаточна перемога!"
      }
    },

    84: {
      name: "Послання до Римлян",
      challenge: "Не соромлюся Євангелія; воно є сила Божа на спасіння...",
      easy: {
        question: "Яке послання найбільше розвиває вчення про спасіння вірою?",
        options: ["1 Коринфянам", "Галатам", "Римлянам", "Ефесянам"],
        correctAnswer: 2,
        hint: "'Теологічний собор' Павла",
        funFact: "🏛️ Римлянам: теологічний шедевр, який звернув Августина і Лютера!"
      },
      medium: {
        question: "Згідно з Римлянам, як людина виправдовується перед Богом?",
        options: [
          "Добрими справами",
          "Тільки вірою, без справ",
          "Жертвами",
          "Традицією"
        ],
        correctAnswer: 1,
        hint: "Основний принцип Реформації",
        funFact: "⚖️ 'Праведний вірою житиме' - духовна революція Павла!"
      },
      hard: {
        question: "Який універсальний масштаб має це послання?",
        options: [
          "Стосується лише римлян",
          "Воно викладає план спасіння для всього людства",
          "Воно критикує лише Рим",
          "Воно застаріло"
        ],
        correctAnswer: 1,
        hint: "Про глобальний план спасіння",
        funFact: "🌍 Євангелія = сила Божа для всіх: іудеїв і греків - повна універсальність!"
      }
    },

    85: {
      name: "Гімн Любові - 1 Коринфянам 13",
      challenge: "Якщо я говорю мовами людськими й ангельськими, а любові не маю...",
      easy: {
        question: "Який розділ Біблії називають 'гімном любові'?",
        options: [
          "1 Коринфянам 12",
          "1 Коринфянам 13",
          "1 Івана 4",
          "Римлянам 8"
        ],
        correctAnswer: 1,
        hint: "Центральний розділ 1 Коринфянам",
        funFact: "💝 Найбільш читаний розділ на весіллях - досконале визначення любові!"
      },
      medium: {
        question: "Що Павло говорить про довговічність любові?",
        options: [
          "Любов минає з часом",
          "Любов ніколи не перестає",
          "Любов залежить від обставин",
          "Любов тимчасова"
        ],
        correctAnswer: 1,
        hint: "Вічність Божої любові",
        funFact: "♾️ Тільки любов переходить через смерть і вічність - найвища цінність!"
      },
      hard: {
        question: "Чому Павло ставить любов вище за духовні дари?",
        options: [
          "Дари погані",
          "Любов дає значення і цінність всьому іншому",
          "Любов легша",
          "Дари розділяють"
        ],
        correctAnswer: 1,
        hint: "Про рушій і значення всього служіння",
        funFact: "🎯 Без любові навіть найбільші дари стають галасом і гордістю!"
      }
    },

    86: {
      name: "Ефесянам: Церква як Тіло Христа",
      challenge: "Він усе підкорив під ноги Його, і поставив Його главою Церкви...",
      easy: {
        question: "Згідно з Ефесянам, що є Церква для Христа?",
        options: [
          "Його Храм",
          "Його Тіло",
          "Його Родина",
          "Його Армія"
        ],
        correctAnswer: 1,
        hint: "Органічна метафора єдності",
        funFact: "👤 Тіло Христа: кожен християнин є важливим членом - взаємозалежність!"
      },
      medium: {
        question: "Яку зброю описує Павло для духовної боротьби?",
        options: [
          "Фізичну зброю",
          "Божу зброю: істина, справедливість, мир, віра, спасіння, Слово",
          "Римську зброю",
          "Магічний захист"
        ],
        correctAnswer: 1,
        hint: "Шість елементів духовної зброї",
        funFact: "⚔️ Духовна війна духовною зброєю - стратегія Божої перемоги!"
      },
      hard: {
        question: "Проти кого наша справжня боротьба згідно з Павлом?",
        options: [
          "Проти поганих людей",
          "Проти духовних сил зла",
          "Проти уряду",
          "Проти бідності"
        ],
        correctAnswer: 1,
        hint: "Про невидимі духовні сили",
        funFact: "👹 Космічна війна: за людськими конфліктами стоїть реальна духовна битва!"
      }
    },

    87: {
      name: "Філіпійцям: Радість у Випробуваннях",
      challenge: "Радійте завжди в Господі; і знову кажу: радійте!",
      easy: {
        question: "Яке почуття заохочує Павло, незважаючи на те, що він у в'язниці?",
        options: ["Розпач", "Радість", "Гнів", "Смуток"],
        correctAnswer: 1,
        hint: "Дивне почуття для в'язня",
        funFact: "😊 Радість 16 разів у 4 розділах - рекорд радості з в'язниці!"
      },
      medium: {
        question: "Згідно з Філіпійцям 2, яку позицію прийняв Ісус?",
        options: [
          "Він нав'язав силою",
          "Він принизив Себе і смирився до смерті",
          "Він уник відповідальності",
          "Він шукав слави"
        ],
        correctAnswer: 1,
        hint: "Добровільний шлях приниження",
        funFact: "📉 Ісус: від рівності з Богом до смерті на хресті - перевернута любов!"
      },
      hard: {
        question: "Як Павло може проповідувати радість з в'язниці?",
        options: [
          "Він вдає",
          "Християнська радість перевершує обставини",
          "Він мазохіст",
          "Він заперечує реальність"
        ],
        correctAnswer: 1,
        hint: "Про надприродну радість",
        funFact: "✨ Радість = плід Духа незалежно від обставин - таємниця Бога!"
      }
    },

    88: {
      name: "Пастирські Послання",
      challenge: "Подвизайся добрим подвигом віри, здобувай вічне життя...",
      easy: {
        question: "Кому Павло написав свої останні пастирські послання?",
        options: [
          "Коринфянам",
          "Тимофію та Титу",
          "Римлянам",
          "Галатам"
        ],
        correctAnswer: 1,
        hint: "Його духовні сини і співробітники",
        funFact: "👨‍👦 Духовна спадщина: Павло передає факел наступному поколінню!"
      },
      medium: {
        question: "Яку пораду дає Павло щодо вибору церковних лідерів?",
        options: [
          "Вибирай найбагатших",
          "Вибирай за суворими моральними і духовними критеріями",
          "Вибирай найосвіченіших",
          "Вибирай найпопулярніших"
        ],
        correctAnswer: 1,
        hint: "Моральні якості насамперед",
        funFact: "⚖️ Високі стандарти для лідерів: характер перед здібностями - пріоритети Бога!"
      },
      hard: {
        question: "Яку спадщину Павло залишає Тимофію?",
        options: [
          "Матеріальні багатства",
          "Вірність Євангелії та пастирське служіння",
          "Політичну посаду",
          "Теологічну школу"
        ],
        correctAnswer: 1,
        hint: "Про духовну спадщину",
        funFact: "📜 'Зберігай добру скарбницю' - вірна передача Євангелія через століття!"
      }
    },

    89: {
      name: "Євреям: Ісус Первосвященик",
      challenge: "Маємо Первосвященика, який пройшов небеса...",
      easy: {
        question: "Згідно з Євреям, хто наш Первосвященик?",
        options: ["Аарон", "Мойсей", "Ісус", "Мелхіседек"],
        correctAnswer: 2,
        hint: "Досконалий посередник між Богом і людьми",
        funFact: "✝️ Ісус: і Священик, і Жертва - досконала жертва раз і назавжди!"
      },
      medium: {
        question: "Чому священство Ісуса вище за священство Аарона?",
        options: [
          "Воно старше",
          "Воно вічне за чином Мелхіседека",
          "Воно багатше",
          "Воно відоміше"
        ],
        correctAnswer: 1,
        hint: "Вічність проти тимчасовості",
        funFact: "♾️ Вічне священство: Ісус завжди заступається за нас!"
      },
      hard: {
        question: "Як Євреям показує Новий Завіт?",
        options: [
          "Такий самий як старий",
          "Кращий і остаточний, написаний на серцях",
          "Тимчасовий",
          "Необов'язковий"
        ],
        correctAnswer: 1,
        hint: "Про виконання і перевершення",
        funFact: "📋 Новий Завіт: закон написаний на серцях, а не на камені!"
      }
    },

    90: {
      name: "Якова: Віра та Справи",
      challenge: "Віра без справ мертва...",
      easy: {
        question: "Згідно з Яковом, що повинно супроводжувати віру?",
        options: [
          "Слова",
          "Справи",
          "Почуття",
          "Знання"
        ],
        correctAnswer: 1,
        hint: "Практична демонстрація віри",
        funFact: "🌳 Віра = коріння, справи = плоди - повне духовне дерево!"
      },
      medium: {
        question: "З чим Яков порівнює язик?",
        options: [
          "З мечем",
          "З маленьким вогнем, що запалює великий ліс",
          "З музичним інструментом",
          "З інструментом"
        ],
        correctAnswer: 1,
        hint: "Маленький орган, але велика руйнівна сила",
        funFact: "🔥 Язик: маленький член, але може спалити все життя - обережно!"
      },
      hard: {
        question: "Як ми узгоджуємо Якова і Павла щодо віри/справ?",
        options: [
          "Вони суперечать",
          "Павло говорить про виправдання, Яков про освячення",
          "Хтось помиляється",
          "Немає рішення"
        ],
        correctAnswer: 1,
        hint: "Про два взаємодоповнюючі аспекти",
        funFact: "⚖️ Павло: спасіння вірою / Яков: віра підтверджена справами - досконала гармонія!"
      }
    },

    91: {
      name: "Одкровення: Повернення Царя",
      challenge: "Ось, йду скоро. Блаженний, хто зберігає слова пророцтва цієї книги!",
      easy: {
        question: "До скількох церков пише Іван в Одкровенні?",
        options: ["5", "7", "10", "12"],
        correctAnswer: 1,
        hint: "Число досконалості",
        funFact: "⛪ 7 церков Азії: дзеркало всіх церков усіх часів!"
      },
      medium: {
        question: "Як закінчується історія згідно з Одкровенням?",
        options: [
          "Повне знищення",
          "Нове небо і нова земля",
          "Повернення до земного раю",
          "Кінець всього існування"
        ],
        correctAnswer: 1,
        hint: "Повне відновлення творіння",
        funFact: "🌅 Не кінець світу, а повне відновлення - остаточна надія!"
      },
      hard: {
        question: "Яке центральне послання несе Одкровення переслідуваним?",
        options: [
          "Здайтеся",
          "Христос править і переможе в кінці",
          "Тікайте від переслідувань",
          "Помстіться"
        ],
        correctAnswer: 1,
        hint: "Про надію остаточної перемоги",
        funFact: "👑 'Який був, є і грядеться' - Господь історії і часу!"
      }
    }
  }
};

export default chapter7Translations;
